import axios from 'axios';
import { getConfig, getUserToken, getUserProperty } from '../util/helper';

const convertTokenServiceKey = (service) => {
  const services = {
    smartAPI: 'smart_api',
  };
  return services[service] ? services[service] : service;
};

const getIdAplicacao = async () => {
  const config = await getConfig();
  return config.idAplicacao;
};

const getIdCliente = async () => {
  const config = await getConfig();
  return config.idCliente;
};

const checkExpiredLogin = (error) => {
  if (error.response && error.response.status === 401) {
    window.location.href = '#/login';
  }
  return error;
};

const api = async (service = 'consulta') => {
  const config = await getConfig(service);
  const session = getUserProperty();
  const tokenKey = convertTokenServiceKey(service);
  const tokenAuthorization = getUserToken(tokenKey)
    ? `bearer ${getUserToken(tokenKey)}`
    : '';

  const xAccessToken = getUserToken('Authenticated')
    ? `${getUserToken('Authenticated')}`
    : '';

  const client = axios.create({
    headers: {
      Authorization: tokenAuthorization,
      'x-access-token': xAccessToken,
      idaplicacao: session.current_idaplicacao || '',
      idaplicacaocliente: session.current_idaplicacaocliente || '',
    },
    baseURL: config.baseUrl || '127.0.0.1',
  });

  if (service === 'upload') {
    client.headers['Content-Type'] = 'multipart/form-data';
    client.headers.storage = config.storage;
  }

  const source = axios.CancelToken.source();
  const defaultConfig = {
    cancelToken: source.token,
  };

  return {
    post: (url, data, _config) => client
      .post(url, data, {
        ..._config,
        ...defaultConfig,
      })
      .then((result) => result)
      .catch((error) => {
        const err = checkExpiredLogin(error);
        throw err;
      }),
    put: (url, data, _config) => client
      .put(url, data, {
        ..._config,
        ...defaultConfig,
      })
      .then((result) => result)
      .catch((error) => {
        throw error;
      }),
    get: (url, data, _config = {}) => client
      .get(url, data, {
        ..._config,
        ...defaultConfig,
      })
      .then((result) => result)
      .catch((error) => {
        const err = checkExpiredLogin(error);
        throw err;
      }),
    delete: (url, data, _config = {}) => client
      .delete(url, { data }, {
        ..._config,
        ...defaultConfig,
      })
      .then((result) => result)
      .catch((error) => {
        const err = checkExpiredLogin(error);
        throw err;
      }),
    cancelRequest: (message = 'Operation canceled by the user.') => source.cancel(message),
  };
};

export default api;

export { getIdAplicacao, getIdCliente };
